<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'compensation',
      breadcrumb: [
        { name: "合同管理", path: `/contract/makeup` },
        { name: "合同补差", path: `/contract/makeup` },
        { name: "合同补差添加" },
      ],
      form: {
        contractid: undefined,
        money: undefined,
        edittime: undefined,
      },
      rules: {
        contractid: [
          { required: true, message: "请选择合同", trigger: "blur" },
        ],
        money: [
          { required: true, message: "请填写补差金额", trigger: "blur" },
        ],
        edittime: [
          { required: true, message: "请选择补差时间", trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "选择合同",
          keyName: "contractid",
          err: "请选择合同",
          type: "select",
          options: [],
        },
        {
          label: "补差金额",
          keyName: "money",
          err: "请填写补差金额",
          type: "number",
        },
        {
          label: "补差时间",
          keyName: "edittime",
          err: "请选择补差时间",
          type: "date",
        },
        {
          label: "备注信息",
          keyName: "content",
          err: "请填写备注",
          type: "textarea",
          rows: 2,
        },
      ],
    };
  },
  methods: {
    setOptions({ contract }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'contractid' && contract.length) {
          c.options = contract.map(v => {
            return {
              label: v.con_num+"-"+v.shname,
              value: v.id,
            }
          })
          console.log(c.options)
        }
      })
      this.$forceUpdate()
    },
  },
  mounted() {
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
